import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Table,
  Container,
  Row,
  Spinner,
  Col,
  Label,
  // Lable,
  CardBody,
  Form,
  Button,
  InputGroup,
  InputGroupAddon,
  Input,
  InputGroupText,
  FormGroup,
  Modal,
  ModalHeader,
  Dropdown,
  UncontrolledTooltip,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify"; // Import Toastify
import "react-toastify/dist/ReactToastify.css";
import React, { useState, useEffect } from "react";
import { FaCheck, FaRegClock } from "react-icons/fa";
import axios from "axios";
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";

import { FaWallet, FaUser, FaExchangeAlt } from "react-icons/fa";
const Tables = () => {
  const [loading, setLoading] = useState(true);

  // Unique function to toggle dropdown
  // view model
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedViewOrder, setSelectedViewOrder] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // You can adjust this number
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/orders`,
        );
        setOrders(response.data.orders); // Store the fetched orders in state
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoading(false); // Set loading to false once data is loaded
      }
    };

    fetchOrders(); // Fetch orders when the component mounts
  }, []);
  // Toggle modal visibility
  const toggleViewModal = () => setIsViewModalOpen(!isViewModalOpen);

  // Handle view button click
  const handleViewClick = (order) => {
    setSelectedViewOrder(order);
    toggleViewModal(); // Open modal
  };

  const [activeFirstRowButton, setActiveFirstRowButton] = useState("ViewAll");
  const [payCurrencies, setPayCurrencies] = useState([]);
  const [users, setUsers] = useState([]);
  const [activeThirdRowButton, setActiveThirdRowButton] = useState("Tranx");
  const [stages, setStages] = useState([]);
  const [dropdownOpenType, setDropdownOpenType] = useState(false);
  const [dropdownOpenStatus, setDropdownOpenStatus] = useState(false);
  const [dropdownOpenStage, setDropdownOpenStage] = useState(false);
  const [dropdownOpenPayMethod, setDropdownOpenPayMethod] = useState(false);
  const [dropdownOpenPayCurrency, setDropdownOpenPayCurrency] = useState(false);
  const [dropdownOpenDateWithin, setDropdownOpenDateWithin] = useState(false);

  const [selectedType, setSelectedType] = useState("Type");
  const [selectedStatus, setSelectedStatus] = useState("Status");
  const [selectedStage, setSelectedStage] = useState("Stage");
  const [selectedPayMethod, setSelectedPayMethod] = useState("Pay Method");
  const [selectedPayCurrency, setSelectedPayCurrency] =
    useState("Pay Currency");
  const [selectedDateWithin, setSelectedDateWithin] = useState("Date Within");

  const toggleDropdownStatus = () => setDropdownOpenStatus(!dropdownOpenStatus);
  const toggleDropdownType = () => setDropdownOpenType(!dropdownOpenType);
  const toggleDropdownStage = () => setDropdownOpenStage(!dropdownOpenStage);
  const toggleDropdownPayMethod = () =>
    setDropdownOpenPayMethod(!dropdownOpenPayMethod);
  const toggleDropdownPayCurrency = () =>
    setDropdownOpenPayCurrency(!dropdownOpenPayCurrency);
  const toggleDropdownDateWithin = () =>
    setDropdownOpenDateWithin(!dropdownOpenDateWithin);

  // Fetch users data and orders data

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/orders`)
      .then((response) => response.json())
      .then((data) => {
        setOrders(data.orders.reverse());
        setFilteredOrders(data.orders);

        // Filter out null, undefined, or empty stages and ensure case-insensitive uniqueness
        const uniqueStages = [
          ...new Set(
            data.orders.map((order) =>
              order.metadata ? order.metadata.stage : null,
            ),
          ),
        ];

        setStages(uniqueStages);
      })
      .catch((error) => {
        console.error("Error fetching orders:", error);
      });
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/orders`)
      .then((response) => response.json())
      .then((data) => {
        setOrders(data.orders.reverse());
        setFilteredOrders(data.orders);

        // Filter out null, undefined, or empty currencies
        const uniqueCurrencies = [
          ...new Set(
            data.orders
              .map((order) => order.currency)
              .filter((currency) => currency && currency.trim() !== ""),
          ),
        ];
        setPayCurrencies(uniqueCurrencies);
      })
      .catch((error) => {
        console.error("Error fetching orders:", error);
      });
  }, []);

  const handleFirstRowButtonClick = (buttonName) => {
    setActiveFirstRowButton(buttonName);
    setCurrentPage(1); // Set clicked button as active in the first row
  };

  const handleTypeSelect = (value) => {
    setSelectedType(value);
    setDropdownOpenType(false);
  };

  const handleStageSelect = (value) => {
    setSelectedStage(value);
    setDropdownOpenStage(false);
  };

  const handlePayMethodSelect = (value) => {
    setSelectedPayMethod(value);
    setDropdownOpenPayMethod(false);
  };

  const handlePayCurrencySelect = (currency) => {
    setSelectedPayCurrency(currency);
    setDropdownOpenPayCurrency(false);
  };

  const handleDateWithinSelect = (value) => {
    setSelectedDateWithin(value);
    setDropdownOpenDateWithin(false);
  };

  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchType, setSearchType] = useState(""); // Track search type (wallet, id, or hash)
  const [searchbywallet, setsearchbywallet] = useState("");

  // Update the search type when a button is clicked
  const handleThirdRowButtonClick = (buttonName) => {
    setActiveThirdRowButton(buttonName); // Set clicked button as active
    setSearchType(buttonName);
    // Update the search type (wallet, id, or hash)
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    const fetchData = async () => {
      // Fetch users, orders, and locations concurrently
      const token = localStorage.getItem("token"); // or 'token', 'accessToken', etc.

      if (!token) {
        console.error("No authentication token found");
        // Optional: Redirect to login or handle unauthorized
        return;
      }

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      // Fetch users, orders, and locations concurrently with auth headers
      const [usersResponse, ordersResponse, locationsResponse] =
        await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/users`, { headers }),
          fetch(`${process.env.REACT_APP_API_URL}/orders`, { headers }),
          fetch(`${process.env.REACT_APP_API_URL}/locations`, { headers }),
        ]);
      const [usersData, ordersData, locationsData] = await Promise.all([
        usersResponse.json(),
        ordersResponse.json(),
        locationsResponse.json(),
      ]);
      console.log(ordersData);

      // Create a map of user_id to email for quick lookup
      const usersMap = usersData.users.reduce((acc, user) => {
        acc[user._id] = user.email; // Map user.orderId to user.email
        return acc;
      }, {});

      // Combine orders with the matched country from locations data
      const ordersWithEmailAndCountry = ordersData.orders
        .reverse()
        .map((order) => {
          // Find the matching location based on user_id (case-insensitive comparison)
          const matchingLocation = {};

          // Add email from usersMap and country from locationsData to the order
          return {
            ...order,
            email: usersMap[order.user_id] || "With Wallet", // Default to 'Email Not Found' if not found
            country: matchingLocation ? matchingLocation.country : "Unknown", // Default to 'Unknown' if no match
          };
        });

      // Set the orders with email and country added
      setOrders(ordersWithEmailAndCountry);
      setFilteredOrders(ordersWithEmailAndCountry); // Initialize filtered orders
    };
    fetchData();
  }, []);

  // Filter the orders based on the selected criteria
  const filterOrders = () => {
    let filtered = orders;

    if (searchQuery) {
      filtered = filtered.filter((order) =>
        order.orderId.toString().includes(searchQuery),
      );
    }

    if (searchbywallet && searchType) {
      // Filter based on the selected search type
      filtered = filtered.filter((order) => {
        // Ensure order.wallet, order.orderId, and order.transaction_hash are not null or undefined
        if (searchType === "walletaddress" && order.wallet) {
          return order.wallet.toString().includes(searchbywallet); // Filter by wallet address
        } else if (searchType === "id" && order.orderId) {
          return order.orderId.toString().includes(searchbywallet); // Filter by ID
        } else if (searchType === "hash" && order.txHash) {
          return order.txHash.toString().includes(searchbywallet); // Filter by transaction hash
        }
        return false;
      });
    }

    if (selectedType === "With Email") {
      // Filter for orders where the email exists and is not empty
      filtered = filtered.filter((order) => order.email !== "With Wallet");
    }

    if (selectedType === "With Wallet") {
      // Filter for orders where the email does not exist or is "Email Not Found"
      filtered = filtered.filter((order) => order.email === "With Wallet");
    }

    if (selectedStatus && selectedStatus !== "Status") {
      filtered = filtered.filter((order) => order.status === selectedStatus);
    }
    if (selectedStatus && selectedStatus !== "Status") {
      filtered = filtered.filter(
        (order) =>
          order.status &&
          order.status.toLowerCase() === selectedStatus.toLowerCase(),
      );
    }

    if (selectedPayCurrency && selectedPayCurrency !== "Pay Currency") {
      filtered = filtered.filter(
        (order) =>
          order.currency &&
          order.currency.toLowerCase() === selectedPayCurrency.toLowerCase(),
      );
    }
    // Pay Method filter (case-insensitive, excluding null values)
    if (selectedPayMethod && selectedPayMethod !== "Pay Method") {
      filtered = filtered.filter(
        (order) =>
          order.provider &&
          order.provider.toLowerCase() === selectedPayMethod.toLowerCase(),
      );
    }

    if (selectedStage && selectedStage !== "Stage") {
      filtered = filtered.filter(
        (order) => order.metadata && order.metadata.stage === selectedStage,
      );
    }
    if (selectedDateWithin && selectedDateWithin !== "Date Within") {
      const today = new Date();
      let dateLimit;

      if (selectedDateWithin === "Last 7 Days") {
        // Calculate the date 7 days ago
        dateLimit = new Date(today);
        dateLimit.setDate(today.getDate() - 7);
      } else if (selectedDateWithin === "Last 30 Days") {
        // Calculate the date 30 days ago
        dateLimit = new Date(today);
        dateLimit.setDate(today.getDate() - 30);
      } else if (selectedDateWithin === "Previous Month") {
        // Get the first day of the previous month
        const firstDayPrevMonth = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1,
        );

        // Get the last day of the previous month
        const lastDayPrevMonth = new Date(
          today.getFullYear(),
          today.getMonth(),
          0,
        );

        // Filter orders where the createdAt is between the first and last day of the previous month
        filtered = filtered.filter((order) => {
          const orderDate = new Date(order.createdAt); // Ensure 'createdAt' is a valid date string
          return (
            orderDate >= firstDayPrevMonth && orderDate <= lastDayPrevMonth
          ); // Compare the dates
        });
      }
    }

    if (activeFirstRowButton === "confirmed") {
      filtered = filtered.filter((order) => order.status === "confirmed");
    } else if (activeFirstRowButton === "pending") {
      filtered = filtered.filter((order) => order.status === "pending");
    }
    // else if (activeFirstRowButton === "pending") {
    //   filtered = filtered.filter((order) => order.status === "PENDING");
    // }
    // First, filter out orders where the fields are null

    // Then, if the activeFirstRowButton is "Bonuses", apply the bonus code filter
    if (activeFirstRowButton === "Bonuses") {
  filtered = filtered.filter((order) => {
    // Check if bonus_code exists and is not empty
    const hasBonusCode = order.bonus_code && order.bonus_code.trim() !== "";
    
    // Check if promo_code exists and is not empty
    const hasPromoCode = order.promoCode && order.promoCode.trim() !== "";

    // Return true if either condition is met
    return hasBonusCode || hasPromoCode;
  });
}
    // if (activeFirstRowButton === "Bonuses") {
    //   filtered = filtered.filter((order) => {
    //     // Make sure the bonus_code exists and isn't an empty string (after trimming)
    //     return order.bonus_code && order.bonus_code.trim() !== "";
    //   });
    // }

    setFilteredOrders(filtered);
    filtered = filtered.filter(
      (order) =>
        order.pay_method !== null &&
        order.stages !== null &&
        order.status !== null,
    );
  };

  useEffect(() => {
    filterOrders();
  }, [
    searchQuery,
    selectedType,
    selectedStatus,
    selectedPayCurrency,
    selectedDateWithin,
    selectedStage,
    selectedPayMethod,
    orders,
    activeFirstRowButton,
    searchbywallet,
  ]);

  // Convert JSON data to CSV format
  const convertToCSV = (data) => {
    const header = [
      "Order Number",
      "Token",
      "Amount",
      "Status",
      "Base Amount",
      "Pay Currency",
    ];
    const rows = data.map((order) => [
      order.orderId,
      order.amountWagr,
      order.usdAmount,
      order.status,
      order.usdAmount,
      order.currency,
    ]);

    // Join header and rows to form CSV content
    const csvContent = [
      header.join(","),
      ...rows.map((row) => row.join(",")),
    ].join("\n");
    return csvContent;
  };

  // Function to trigger CSV download
  const downloadCSV = () => {
    const csvData = convertToCSV(filteredOrders);
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const filename = `orders_${new Date().toLocaleDateString()}.csv`;
      link.setAttribute("href", URL.createObjectURL(blob));
      link.setAttribute("download", filename);
      link.click();
    }
  };

  // Function to trigger PDF download
  const downloadPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(16);
    doc.text("Transaction List", 14, 15);
    doc.setFontSize(10);
    doc.text(`Generated on ${new Date().toLocaleString()}`, 14, 22);

    const headers = [
      "Order Number",
      "Date",
      "Price",
      "Amount",
      "Currency",
      "Tokens",
      "Bonus %",
      "Pay Method",
      "Status",
      "Email",
      "Country",
    ];
    const rows = filteredOrders.map((order) => [
      order.orderId || "—",
      order.createdAt ? new Date(order.createdAt).toLocaleDateString() : "—",
      order.metadata?.priceAtPurchaseUSD ?? order?.priceAtPurchaseUSD ?? "N/A",
      order.usdAmount ?? "—",
      order.currency ?? "—",
      order.amountWagr != null
        ? Number(order.amountWagr).toLocaleString()
        : "—",
      order?.promoCode ?? "N/A",
      order.paymentMethod ?? "—",
      order.status ?? "—",
      order.email ?? "—",
      order.country ?? "—",
    ]);

    autoTable(doc, {
      head: [headers],
      body: rows,
      startY: 28,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [37, 29, 12] },
    });

    const filename = `transactions_${new Date().toISOString().slice(0, 10)}.pdf`;
    doc.save(filename);
  };

  // Add state to control modal
  const [modal, setModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [updatedTokens, setUpdatedTokens] = useState("");
  const [updatedOrderStatus, setUpdatedOrderStatus] = useState("");
  const [updatedBonusPercentage, setUpdatedBonusPercentage] = useState("");
  // const [orders, setOrders] = useState([]);
  // const [filteredOrders, setFilteredOrders] = useState([]);

  const toggleModal = () => setModal(!modal);

  const handleEditClick = (order) => {
    setSelectedOrder(order);
    setUpdatedTokens(order.amountWagr);
    setUpdatedOrderStatus(order.status);
    setUpdatedBonusPercentage(order.bonus_percentage || "");
    toggleModal();
  };

  const handleSaveChanges = () => {
    if (selectedOrder) {
      const originalTokens = parseFloat(selectedOrder.amountWagr); // Original tokens from the order
      const currentBonusPercentage =
        parseFloat(selectedOrder.bonus_percentage) || 0; // Current bonus percentage applied
      const newBonusPercentage = parseFloat(updatedBonusPercentage) || 0; // New bonus percentage to apply

      // Subtract the current bonus tokens if any
      const tokensWithoutBonus =
        originalTokens / (1 + currentBonusPercentage / 100);

      // Calculate new tokens with the new bonus percentage
      const newTokens = tokensWithoutBonus * (1 + newBonusPercentage / 100);

      // Format to 2 decimal places
      const tokensToSubmit = newTokens.toFixed(2);

      // Send update request to the server
      fetch(`${process.env.REACT_APP_API_URL}/orders/${selectedOrder._id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amountWagr: tokensToSubmit,
          status: updatedOrderStatus,
          promoCode: updatedBonusPercentage,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          setOrders((prevOrders) =>
            prevOrders.map((order) =>
              order.orderId === selectedOrder.orderId
                ? {
                    ...order,
                    tokens: tokensToSubmit,
                    status: updatedOrderStatus,
                    bonus_percentage: updatedBonusPercentage,
                  }
                : order,
            ),
          );
          toggleModal();
          toast.confirmed("Transaction updated confirmedfully");
        })
        .catch((error) => console.error("Error updating order:", error));
    }
  };

  const [basePrice, setBasePrice] = useState(null); // Store the base price
  const [tokens, setTokens] = useState(""); // Store the calculated tokens

  useEffect(() => {
    // Fetch stage data from the API
    const token = localStorage.getItem("token");

    fetch(`${process.env.REACT_APP_API_URL}/stages`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401 || response.status === 403) {
            // Handle authentication error
            localStorage.removeItem("token");
            window.location.href = "/login";
            throw new Error("Authentication failed");
          }
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // Handle new tokenomics structure
        if (data.tokenomics && data.tokenomics.length > 0) {
          const currentTokenomics =
            data.tokenomics.find((item) => item.isCurrent === true) ||
            data.tokenomics[0];
          if (currentTokenomics) {
            setBasePrice(parseFloat(currentTokenomics.priceUSD)); // Set the base price from the current tokenomics
          }
        } else if (data.stages) {
          // Fallback to old structure
          const stages = data.stages;

          // Find the current stage based on the current date
          const currentDate = new Date();
          const currentStage = stages.find((stage) => {
            const startDate = new Date(stage.start_date);
            const endDate = new Date(stage.end_date);
            return currentDate >= startDate && currentDate <= endDate;
          });

          if (currentStage) {
            setBasePrice(parseFloat(currentStage.base_price)); // Set the base price from the current stage
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching stages:", error);
        if (error.message !== "Authentication failed") {
          // Optional: Show user-friendly error message
          // toast.error('Failed to fetch stage data');
        }
      });
  }, []);

  const handleWalletAddressChange = (e) => {
    const walletAddress = e.target.value;
    setOrderWalletAddress(walletAddress);

    // Fetch the user_id based on the entered wallet address
    const user = availableUsers.find((user) => user.wallet === walletAddress);

    if (user) {
      setOrderUserId(user.orderId); // Set userId if a match is found
    } else {
      setOrderUserId(""); // Clear the userId if no match is found
    }
  };

  const [isModalVisible, setIsModalVisible] = useState(false); // Controls modal visibility
  const [orderUserId, setOrderUserId] = useState(""); // User ID for the order
  const [orderWalletAddress, setOrderWalletAddress] = useState(""); // Wallet address for the order
  const [transactionPrice, setTransactionPrice] = useState(""); // Price for the transaction
  const [transactionCurrency, setTransactionCurrency] = useState("USD"); // Currency for the transaction
  const [orderTokens, setOrderTokens] = useState(""); // Tokens associated with the order
  const [currentOrderStatus, setCurrentOrderStatus] = useState("confirmed"); // Order status
  const [paymentCurrency, setPaymentCurrency] = useState(""); // Pay currency
  const [paymentMethod, setPaymentMethod] = useState("NOWPAYMENT"); // Payment method
  const [availableUsers, setAvailableUsers] = useState([]); // List of available users
  const [value, setValue] = useState(); // Default value set to 50
  // Handle wallet address change

  useEffect(() => {
    // Fetch available users from the backend
    const token = localStorage.getItem("token");

    fetch(`${process.env.REACT_APP_API_URL}/users`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401 || response.status === 403) {
            // Handle authentication error
            localStorage.removeItem("token");
            window.location.href = "/login";
            throw new Error("Authentication failed");
          }
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setAvailableUsers(data.orders); // Assuming response contains an array of user objects
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
        if (error.message !== "Authentication failed") {
          // Optional: Show user-friendly error message
          // toast.error('Failed to fetch users');
        }
      });
  }, []);

  const handleModalToggle = () => setIsModalVisible(!isModalVisible); // Toggled modal visibility

  const handleSaveTransaction = () => {
    // Validate if the user_id and wallet exist in the available users
    const isUserValid = availableUsers.some(
      (user) =>
        user.orderId === orderUserId && user.wallet === orderWalletAddress,
    );

    if (!isUserValid) {
      toast.error("User ID or Wallet Address does not exist.");
      return;
    }

    // Prepare the data to be sent to the backend
    const newOrder = {
      user_id: orderUserId,
      wallet: orderWalletAddress,
      price: basePrice,
      currency: transactionCurrency,
      tokens: tokens,
      status: currentOrderStatus,
      pay_currency: paymentCurrency,
      pay_method: paymentMethod,
      value: value, // Include value here
      isfake: false,
    };

    // API call to insert the new order into the backend
    fetch(`${process.env.REACT_APP_API_URL}/orders`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newOrder),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          toast.error("Failed to insert order.");
        } else {
          toast.confirmed("Transaction inserted confirmedfully");
          window.location.reload();
          handleModalToggle(); // Close the modal after confirmedful insertion
        }
      })
      .catch((error) => {
        console.error("Error inserting transaction:", error);
        toast.error("Error inserting transaction.");
      });
  };
  const handleValueChange = (e) => {
    const inputValue = e.target.value;
    setValue(inputValue);

    if (basePrice) {
      const calculatedTokens = (inputValue / basePrice).toFixed(2); // Calculate tokens
      setTokens(calculatedTokens); // Set the calculated tokens
    }
  };
  // State for token modal
  const [tokenModal, setTokenModal] = useState(false);
  const [selectedTokenOrder, setSelectedTokenOrder] = useState(null);
  const [newTokenValue, setNewTokenValue] = useState("");

  // Toggle token modal
  const toggleTokenModal = () => setTokenModal(!tokenModal);
  const handleEditTokenClick = (order) => {
    setSelectedTokenOrder(order); // Set the selected order to edit
    setNewTokenValue(order.amountWagr); // Pre-fill the token value in the modal
    toggleTokenModal(); // Open the token editing modal
  };

  const handleSaveTokenChanges = () => {
    if (selectedTokenOrder) {
      const tokensToSubmit = newTokenValue; // Directly use the manually edited tokens

      // Send the update request to the backend
      fetch(
        `${process.env.REACT_APP_API_URL}/orders/${selectedTokenOrder._id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            amountWagr: tokensToSubmit, // Use amountWagr instead of tokens
            status: selectedTokenOrder.status, // You might want to keep the existing status or set a default
            // promoCode is optional, you can include if needed
          }),
        },
      )
        .then((response) => response.json())
        .then((data) => {
          setOrders((prevOrders) =>
            prevOrders.map((order) =>
              order.orderId === selectedTokenOrder.orderId
                ? { ...order, tokens: tokensToSubmit } // Only update tokens
                : order,
            ),
          );
          toggleTokenModal();
          toast.confirmed("Token updated confirmedfully");
        })
        .catch((error) => console.error("Error updating token:", error));
    }
  };
  // Function to handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Calculate total number of pages
  const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

  // Render pagination controls
  const renderPagination = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }

    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
      >
        <Button
          color="primary"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={{ margin: "0 5px", padding: "5px 10px" }}
        >
          Previous
        </Button>
        <Button
          color="primary"
          style={{ margin: "0 5px", padding: "5px 10px" }}
        >
          Page: {currentPage}
        </Button>
        <Button
          color="primary"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={{ margin: "0 5px", padding: "5px 10px" }}
        >
          Next
        </Button>
      </div>
    );
  };

  return (
    <>
      {/* handle edit token  */}
      {selectedTokenOrder && (
        <Modal isOpen={tokenModal} toggle={toggleTokenModal}>
          <ModalHeader toggle={toggleTokenModal}>Edit Token</ModalHeader>
          <ModalBody style={{ padding: "20px", maxWidth: "600px" }}>
            <div style={{ marginBottom: "15px" }}>
              <label
                style={{
                  marginBottom: "5px",
                  color: "black",
                  fontSize: "20px",
                }}
              >
                Order ID : {selectedTokenOrder.orderId}
              </label>
              <br />
              <label
                style={{
                  marginBottom: "5px",
                  color: "black",
                  fontSize: "20px",
                }}
              >
                Tokens
              </label>
              <Input
                type="text"
                value={newTokenValue}
                onChange={(e) => setNewTokenValue(e.target.value)} // Use the new state here
                style={{ padding: "10px", fontSize: "16px" }}
                disabled={selectedTokenOrder.status === "confirmed"} // Disable input if order status is "PENDING"
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={handleSaveTokenChanges}
              style={{ padding: "10px 20px" }}
            >
              Save Changes
            </Button>{" "}
            <Button
              color="secondary"
              onClick={toggleTokenModal}
              style={{ padding: "10px 20px" }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      )}

      {/* view model  */}
      <Modal
        style={{
          maxWidth: "70%",
          width: "80%",
          height: "50vh",
        }}
        isOpen={isViewModalOpen}
        toggle={toggleViewModal}
      >
        <ModalHeader toggle={toggleViewModal}>Order Details</ModalHeader>
        <ModalBody>
          {selectedViewOrder && (
            <div>
              <p style={{ color: "black" }}>
                <strong>Order ID:</strong> {selectedViewOrder.orderId}
              </p>
              <p style={{ color: "black" }}>
                <strong>User ID:</strong> {selectedViewOrder.userId._id}
              </p>
              <p style={{ color: "black" }}>
                <strong>Wallet Address:</strong> {selectedViewOrder.wallet}
              </p>
              <p style={{ color: "black" }}>
                <strong>Transaction Hash:</strong>{" "}
                {selectedViewOrder?.txHash ||
                  selectedViewOrder?.providerPaymentId}
              </p>
              <p style={{ color: "black" }}>
                <strong>Price:</strong> {selectedViewOrder.usdAmount}
              </p>
              <p style={{ color: "black" }}>
                <strong>Value:</strong> {selectedViewOrder.usdAmount}
              </p>
              <p style={{ color: "black" }}>
                <strong>Currency:</strong> {selectedViewOrder.currency}
              </p>
              <p style={{ color: "black" }}>
                <strong>Tokens:</strong> {selectedViewOrder.amountWagr}
              </p>
              <p style={{ color: "black" }}>
                <strong>Status:</strong> {selectedViewOrder.status}
              </p>
              <p style={{ color: "black" }}>
                <strong>Email:</strong> {selectedViewOrder.email}
              </p>
              {/* <p style={{color:'black'}}><strong>Country:</strong> {selectedViewOrder.country}</p> */}
              <p style={{ color: "black" }}>
                <strong>Bonus Code:</strong> {selectedViewOrder.promoCode}
              </p>
              {/* <p style={{color:'black'}}><strong>Bonus Persentage:</strong> {selectedViewOrder.bonus_percentage}%</p> */}
              <p style={{ color: "black" }}>
                <strong>Pay Method:</strong> {selectedViewOrder.paymentMethod}
              </p>
              <p style={{ color: "black" }}>
                <strong>Block:</strong> {selectedViewOrder.block}
              </p>
              {/* <p style={{color:'black'}}><strong>isFake:</strong> {selectedViewOrder.isfake}</p> */}
              <p style={{ color: "black" }}>
                <strong>Created At:</strong>{" "}
                {new Date(selectedViewOrder.createdAt).toLocaleDateString()}
              </p>
              {/* Add any other details you'd like to display */}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleViewModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={isModalVisible} toggle={handleModalToggle}>
        <ModalHeader toggle={handleModalToggle}>
          Insert New Transaction
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label style={{ color: "black" }} for="userId">
              User ID
            </Label>
            <Input
              type="text"
              name="userId"
              id="userId"
              value={orderUserId}
              readOnly // Make the input read-only
              placeholder="User ID"
            />
          </FormGroup>

          <FormGroup>
            <Label style={{ color: "black" }} for="walletAddress">
              Wallet Address
            </Label>
            <Input
              type="text"
              name="walletAddress"
              id="walletAddress"
              value={orderWalletAddress}
              onChange={handleWalletAddressChange} // Call handleWalletAddressChange when the wallet address changes
              placeholder="Enter Wallet Address"
            />
          </FormGroup>
          <FormGroup>
            <Label style={{ color: "black" }} for="value">
              Value
            </Label>
            <Input
              type="number"
              name="value"
              id="value"
              value={value}
              onChange={handleValueChange}
              placeholder="Enter Value"
            />
          </FormGroup>

          <FormGroup>
            <Label style={{ color: "black" }} for="price">
              Current Stage Base Price
            </Label>
            <Input
              type="text"
              name="price"
              id="price"
              value={basePrice || "Loading..."} // Display base price or loading
              readOnly
              placeholder="Base Price"
            />
          </FormGroup>

          <FormGroup>
            <Label style={{ color: "black" }} for="tokens">
              Total Tokens
            </Label>
            <Input
              type="text"
              name="tokens"
              id="tokens"
              value={tokens}
              readOnly
              placeholder="Calculated Tokens"
            />
          </FormGroup>

          <FormGroup>
            <Label style={{ color: "black" }} for="currency">
              Currency
            </Label>
            <Input
              type="text"
              name="currency"
              id="currency"
              value={transactionCurrency}
              onChange={(e) => setTransactionCurrency(e.target.value)}
              placeholder="Enter Currency"
            />
          </FormGroup>

          <FormGroup>
            <Label style={{ color: "black" }} for="status">
              Order Status
            </Label>
            <Input
              type="select"
              name="status"
              id="status"
              value={currentOrderStatus}
              onChange={(e) => setCurrentOrderStatus(e.target.value)}
            >
              <option value="confirmed">confirmed</option>
              <option value="pending">PENDING</option>
              <option value="FAILED">FAILED</option>
            </Input>
          </FormGroup>

          <FormGroup>
            <Label style={{ color: "black" }} for="payCurrency">
              Payment Currency
            </Label>
            <Input
              type="text"
              name="payCurrency"
              id="payCurrency"
              value={paymentCurrency}
              onChange={(e) => setPaymentCurrency(e.target.value)}
              placeholder="Enter Pay Currency"
            />
          </FormGroup>

          <FormGroup>
            <Label style={{ color: "black" }} for="payMethod">
              Payment Method
            </Label>
            <Input
              type="select"
              name="payMethod"
              id="payMethod"
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
            >
              <option value="DIRECTPAYMENT">DIRECTPAYMENT</option>
              <option value="NOWPAYMENT">NOWPAYMENT</option>
              {/* <option value="BANKTRANSFER">BANKTRANSFER</option> */}
            </Input>
          </FormGroup>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={handleModalToggle}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSaveTransaction}>
            Save Transaction
          </Button>
        </ModalFooter>
      </Modal>
      <ToastContainer position="top-center" />

      {/* Modal for Editing */}
      {selectedOrder && (
        <Modal isOpen={modal} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>Edit Order</ModalHeader>
          <ModalBody style={{ padding: "20px", maxWidth: "600px" }}>
            <div style={{ marginBottom: "15px" }}>
              <label
                style={{
                  marginBottom: "5px",
                  color: "black",
                  fontSize: "20px",
                }}
              >
                Order ID : {selectedOrder.orderId}
              </label>
              <br />
              <label
                style={{
                  marginBottom: "5px",
                  color: "black",
                  fontSize: "20px",
                }}
              >
                Tokens
              </label>
              <Input
                type="text"
                value={updatedTokens}
                onChange={(e) => setUpdatedTokens(e.target.value)}
                readOnly
                style={{ padding: "10px", fontSize: "16px" }}
              />
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label
                style={{
                  marginBottom: "5px",
                  color: "black",
                  fontSize: "20px",
                }}
              >
                Order Status :{" "}
              </label>
              <Dropdown
                isOpen={dropdownOpenStatus}
                toggle={() => setDropdownOpenStatus(!dropdownOpenStatus)}
              >
                <DropdownToggle
                  caret
                  style={{
                    padding: "10px",
                    fontSize: "16px",
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  {updatedOrderStatus}
                </DropdownToggle>
                <DropdownMenu>
                  {updatedOrderStatus === "pending" && (
                    <DropdownItem
                      onClick={() => setUpdatedOrderStatus("confirmed")}
                    >
                      confirmed
                    </DropdownItem>
                  )}
                </DropdownMenu>
              </Dropdown>
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label
                style={{
                  marginBottom: "5px",
                  color: "black",
                  fontSize: "20px",
                }}
              >
                Bonus Percentage
              </label>

              <Input
                type="number"
                value={updatedBonusPercentage}
                onChange={(e) => setUpdatedBonusPercentage(e.target.value)}
                disabled={updatedOrderStatus !== "pending"}
                style={{ padding: "10px", fontSize: "16px" }}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={handleSaveChanges}
              style={{ padding: "10px 20px" }}
            >
              Save Changes
            </Button>{" "}
            <Button
              color="secondary"
              onClick={toggleModal}
              style={{ padding: "10px 20px" }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      )}

      {/* <Filter/> */}
      {/* <Header /> */}
      {/* Page content */}
      <Container
        className=""
        style={{ background: "#251d0c", paddingTop: "100px", maxWidth: "100%" }}
      >
        <Row style={{ background: "black" }}>
          <Col className="order-xl-1" xl="12" style={{ background: "#251d0c" }}>
            <Card
              className="shadow"
              style={{ backgroundColor: "black", color: "#FFB000" }}
            >
              <CardBody style={{ backgroundColor: "black", color: "white" }}>
                <Form>
                  <CardHeader
                    style={{
                      background:
                        "linear-gradient(270deg, #9e6400 0%, #FFB000 100%)",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                      color: "white",
                    }}
                  >
                    <Row
                      style={{
                        color: "white",
                        padding: "15px",
                        marginLeft: "0",
                        marginRight: "0",
                      }}
                      className="d-flex justify-content-between align-items-center"
                    >
                      {/* Heading aligned to the left */}
                      <h1
                        className="heading-lg mb-4"
                        style={{ color: "black", marginBottom: "0" }}
                      >
                        All Transaction
                      </h1>

                      {/* Search box aligned to the right */}
                      <Col xs="12" sm="12" md="5" className="mb-2 mb-md-0">
                        <InputGroup className="input-group-rounded input-group-merge">
                          <Input
                            aria-label="Search"
                            className="form-control-rounded form-control-prepended"
                            placeholder="Order No to Quick Search"
                            type="search"
                            value={searchQuery}
                            onChange={(e) => {
                              setSearchQuery(e.target.value);
                              setCurrentPage(1);
                            }}
                            style={{
                              backgroundColor: "black",
                              color: "white",
                              border: "none",
                              paddingLeft: "40px", // space for the icon
                              fontSize: "14px", // Adjusted font size
                              marginLeft: "0", // Remove left margin
                              marginRight: "0", // Remove right margin
                            }}
                          />
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText
                              style={{
                                background:
                                  "linear-gradient(180deg, #2A1F0F 0%, rgba(200,140,40,0.6) 40%, rgba(255,176,0,0.55) 50%, rgba(255,176,0,0.65) 55%, rgba(247,190,64,0.75) 75%, rgba(255,176,0,0.65) 100%)", // "linear-gradient(180deg, #2A1F0F 0%, #2A1F0F 30%, rgba(255,176,0,0.75) 45%, rgba(255,176,0,0.65) 55%, rgba(247,190,64,0.6) 70%, rgba(247,190,64,0.5) 85%, rgba(255,176,0,0.8) 95%, #ffb000dc 100%)",
                                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                                color: "white",
                                borderColor: "black",
                              }}
                            >
                              <span
                                className="fa fa-search"
                                style={{ color: "white" }}
                              />
                            </InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      </Col>
                    </Row>

                    <Row className="align-items-center">
                      {/* First row buttons */}
                      <Col xs="12" sm="6" md="3" className="mb-2 mb-md-0">
                        <Button
                          style={{
                            backgroundColor:
                              activeFirstRowButton === "pending"
                                ? "#FFB000"
                                : "black",
                            backgroundColor:
                              activeFirstRowButton === "pending"
                                ? "#FFB000"
                                : "black",
                            color:
                              activeFirstRowButton === "pending"
                                ? "white"
                                : "white",
                            border: "2px solid black", // Remove border
                          }}
                          onClick={() => handleFirstRowButtonClick("pending")}
                          size="lg"
                          block
                        >
                          Pending
                        </Button>
                      </Col>

                      <Col
                        xs="12"
                        sm="6"
                        md="3"
                        className="mb-2 mb-md-0 text-center text-sm-right"
                        style={{ fontSize: "20px" }}
                      >
                        <Button
                          style={{
                            backgroundColor:
                              activeFirstRowButton === "confirmed"
                                ? "#FFB000"
                                : "black",
                            color:
                              activeFirstRowButton === "confirmed"
                                ? "white"
                                : "white",
                            border: "2px solid black", // Remove border// Remove border
                          }}
                          onClick={() => handleFirstRowButtonClick("confirmed")}
                          size="lg"
                          block
                        >
                          Approved
                        </Button>
                      </Col>

                      <Col
                        xs="12"
                        sm="6"
                        md="3"
                        className="mb-2 mb-md-0 text-center text-sm-right"
                        style={{ fontSize: "20px" }}
                      >
                        <Button
                          style={{
                            backgroundColor:
                              activeFirstRowButton === "Bonuses"
                                ? "#FFB000"
                                : "black",
                            color:
                              activeFirstRowButton === "Bonuses"
                                ? "white"
                                : "white",
                            border: "2px solid black", // Remove border// Remove border
                          }}
                          onClick={() => handleFirstRowButtonClick("Bonuses")}
                          size="lg"
                          block
                        >
                          Bonuses
                        </Button>
                      </Col>

                      <Col
                        xs="12"
                        sm="6"
                        md="3"
                        className="mb-2 mb-md-0 text-center text-sm-right"
                        style={{ fontSize: "20px" }}
                      >
                        <Button
                          style={{
                            backgroundColor:
                              activeFirstRowButton === "ViewAll"
                                ? "#FFB000"
                                : "black",
                            color:
                              activeFirstRowButton === "ViewAll"
                                ? "white"
                                : "white",
                            border: "2px solid black", // Remove border // Remove border
                          }}
                          onClick={() => window.location.reload()}
                          size="lg"
                          block
                        >
                          View All
                        </Button>
                      </Col>
                    </Row>
                  </CardHeader>

                  <div
                    className="pl-lg-4"
                    style={{
                      padding: "10px",
                      background:
                        "linear-gradient(270deg, #9e6400 0%, #FFB000 100%)", // Blue gradient
                      color: "white",
                    }}
                  >
                    {/* Third row with "Search by ID" and buttons */}
                    <Row>
                      <Col lg="5" xs="12" className="mb-3">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-search-id"
                            style={{ color: "black" }}
                          >
                            Search by
                          </label>
                          <InputGroup className="input-group">
                            <Input
                              className="form-control-alternative"
                              id="input-search-id"
                              placeholder="Search by"
                              type="text"
                              value={searchbywallet}
                              onChange={(e) => {
                                setsearchbywallet(e.target.value);
                                setCurrentPage(1);
                              }} // Set search term
                              style={{
                                backgroundColor: "black",
                                color: "white",
                              }}
                            />
                            <InputGroupAddon
                              style={{
                                background:
                                  "linear-gradient(to right, #4CAF50, #8BC34A)", // Blue gradient
                                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                                color: "white",
                              }}
                              addonType="append"
                            >
                              <Button
                                style={{
                                  backgroundColor:
                                    activeThirdRowButton === "walletaddress"
                                      ? "#FFB000"
                                      : "black",
                                  color:
                                    activeThirdRowButton === "walletaddress"
                                      ? "white"
                                      : "white",
                                  border: "none",
                                  fontSize: "0.8rem",
                                  paddingLeft: "15px",
                                  paddingRight: "15px",
                                }}
                                onClick={() =>
                                  handleThirdRowButtonClick("walletaddress")
                                }
                              >
                                <FaWallet style={{ fontSize: "20px" }} />{" "}
                                {/* Wallet Icon */}
                              </Button>
                            </InputGroupAddon>
                            <InputGroupAddon addonType="append">
                              <Button
                                style={{
                                  backgroundColor:
                                    activeThirdRowButton === "id"
                                      ? "#FFB000"
                                      : "black",
                                  color:
                                    activeThirdRowButton === "id"
                                      ? "white"
                                      : "white",
                                  border: "none",
                                  fontSize: "0.8rem",
                                  paddingLeft: "15px",
                                  paddingRight: "15px",
                                }}
                                onClick={() => handleThirdRowButtonClick("id")}
                                size="sm"
                              >
                                <FaUser style={{ fontSize: "20px" }} />{" "}
                                {/* User Icon */}
                              </Button>
                            </InputGroupAddon>
                            <InputGroupAddon addonType="append">
                              <Button
                                style={{
                                  backgroundColor:
                                    activeThirdRowButton === "hash"
                                      ? "#FFB000"
                                      : "black",
                                  color:
                                    activeThirdRowButton === "hash"
                                      ? "white"
                                      : "white",
                                  border: "none",
                                  fontSize: "0.8rem",
                                  paddingLeft: "15px",
                                  paddingRight: "15px",
                                }}
                                onClick={() =>
                                  handleThirdRowButtonClick("hash")
                                }
                                size="sm"
                              >
                                <FaExchangeAlt style={{ fontSize: "20px" }} />{" "}
                                {/* Transaction Icon */}
                              </Button>
                            </InputGroupAddon>
                          </InputGroup>
                        </FormGroup>
                      </Col>

                      <Col lg="4" xs="12" className="mb-3">
                        <Row>
                          {/* Type Dropdown */}
                          <Col xs="12" sm="3" md="8" className="mb-2 mb-sm-0">
                            <FormGroup>
                              {/* <Button color="primary" onClick={handleModalToggle}>
        Insert Transaction
      </Button> */}
                              <label
                                className="form-control-label"
                                htmlFor="dropdown-pay-currency"
                                style={{ color: "black" }}
                              >
                                Currency
                              </label>
                              <br />
                              <Dropdown
                                isOpen={dropdownOpenPayCurrency}
                                toggle={toggleDropdownPayCurrency}
                              >
                                <DropdownToggle
                                  caret
                                  style={{
                                    backgroundColor: "black",
                                    color: "white",
                                    border: "none",
                                    fontSize: "0.9rem", // Remove border from the dropdown button
                                  }}
                                >
                                  <span
                                    className="fa fa-cogs"
                                    style={{ marginRight: "10px" }}
                                  />
                                  {selectedPayCurrency}
                                </DropdownToggle>
                                <DropdownMenu
                                  style={{
                                    backgroundColor: "black",
                                    border: "none",
                                    fontSize: "10px",
                                    color: "white",
                                  }}
                                >
                                  {payCurrencies.map((currency, index) => (
                                    <DropdownItem
                                      key={index}
                                      onClick={() => {
                                        handlePayCurrencySelect(currency);
                                        setCurrentPage(1);
                                      }}
                                      style={{
                                        border: "none",
                                        color: "#FFB000",
                                      }}
                                    >
                                      Currency {currency.toUpperCase()}
                                    </DropdownItem>
                                  ))}
                                </DropdownMenu>
                              </Dropdown>
                            </FormGroup>
                          </Col>

                          {/* Status Dropdown */}
                          <Col xs="12" sm="3" md="4" className="mb-2 mb-sm-0">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="dropdown-status"
                                style={{ color: "black" }}
                              >
                                Date Within
                              </label>
                              <br />
                              <Dropdown
                                isOpen={dropdownOpenDateWithin}
                                toggle={toggleDropdownDateWithin}
                              >
                                <DropdownToggle
                                  caret
                                  style={{
                                    backgroundColor: "black",
                                    color: "white",
                                    border: "none",
                                  }}
                                >
                                  <span
                                    className="fa fa-check-circle"
                                    style={{ marginRight: "10px" }}
                                  />
                                  {selectedDateWithin}
                                </DropdownToggle>
                                <DropdownMenu
                                  style={{
                                    backgroundColor: "black",
                                    border: "none",
                                    fontSize: "10px",
                                  }}
                                >
                                  <DropdownItem
                                    onClick={() => {
                                      handleDateWithinSelect("Last 7 Days");
                                      setCurrentPage(1);
                                    }}
                                    style={{ border: "none", color: "#FFB000" }}
                                  >
                                    Last 7 Days
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() => {
                                      handleDateWithinSelect("Last 30 Days");
                                      setCurrentPage(1);
                                    }}
                                    style={{ border: "none", color: "#FFB000" }}
                                  >
                                    Last 30 Days
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() => {
                                      handleDateWithinSelect("Previous Month");
                                      setCurrentPage(1);
                                    }}
                                    style={{ border: "none", color: "#FFB000" }}
                                  >
                                    Previous Month
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row className="align-items-center">
                      {/* Pay Method Dropdown */}
                      <Col xs="12" sm="4" md="3">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="dropdown-pay-method"
                            style={{ color: "black" }}
                          >
                            Pay Method
                          </label>
                          <br />
                          <Dropdown
                            isOpen={dropdownOpenPayMethod}
                            toggle={toggleDropdownPayMethod}
                          >
                            <DropdownToggle
                              caret
                              style={{
                                backgroundColor: "black",
                                color: "white",
                                border: "none",
                              }}
                            >
                              <span
                                className="fa fa-credit-card"
                                style={{ marginRight: "10px" }}
                              />
                              {selectedPayMethod}
                            </DropdownToggle>
                            <DropdownMenu
                              style={{
                                backgroundColor: "black",
                                border: "none",
                                fontSize: "10px",
                              }}
                            >
                              <DropdownItem
                                onClick={() => {
                                  handlePayMethodSelect("NOWPayments");
                                  setCurrentPage(1);
                                }}
                                style={{ border: "none", color: "#FFB000" }}
                              >
                                Via Now Payment
                              </DropdownItem>
                              {/* <DropdownItem onClick={() => handlePayMethodSelect("VIA_CARD")} style={{ border: 'none', color: '#FFB000' }}>
            Via Card
          </DropdownItem> */}
                              <DropdownItem
                                onClick={() => {
                                  handlePayMethodSelect("Wallet");
                                  setCurrentPage(1);
                                }}
                                style={{ border: "none", color: "#FFB000" }}
                              >
                                DIRECTPAYMENT
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </FormGroup>
                      </Col>

                      {/* Stage Dropdown */}
                      {/* <Col xs="12" sm="4" md="2">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="dropdown-stage"
                            style={{ color: "black" }}
                          >
                            Stage
                          </label>
                          <br />
                          <Dropdown
                            isOpen={dropdownOpenStage}
                            toggle={toggleDropdownStage}
                          >
                            <DropdownToggle
                              caret
                              style={{
                                backgroundColor: "black",
                                color: "white",
                                border: "none",
                              }}
                            >
                              <span
                                className="fa fa-cogs"
                                style={{ marginRight: "10px" }}
                              />
                              {selectedStage}
                            </DropdownToggle>
                            <DropdownMenu
                              style={{
                                backgroundColor: "black",
                                border: "none",
                                fontSize: "10px",
                              }}
                            >
                              {stages.map((stage, index) => (
                                <DropdownItem
                                  key={index}
                                  onClick={() => {
                                    handleStageSelect(stage);
                                    setCurrentPage(1);
                                  }}
                                  style={{ border: "none", color: "#FFB000" }}
                                >
                                  {stage}
                                </DropdownItem>
                              ))}
                            </DropdownMenu>
                          </Dropdown>
                        </FormGroup>
                      </Col> hide for now*/} 

                      {/* Tranx Type Dropdown */}
                      <Col xs="12" sm="4" md="2">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="dropdown-type"
                            style={{ color: "black" }}
                          >
                            Tranx Type
                          </label>
                          <br />
                          <Dropdown
                            isOpen={dropdownOpenType}
                            toggle={toggleDropdownType}
                          >
                            <DropdownToggle
                              caret
                              style={{
                                backgroundColor: "black",
                                color: "white",
                                border: "none",
                              }}
                            >
                              <span
                                className="fa fa-cogs"
                                style={{ marginRight: "2px" }}
                              />
                              {selectedType}
                            </DropdownToggle>
                            <DropdownMenu
                              style={{
                                backgroundColor: "black",
                                border: "none",
                                fontSize: "10px",
                              }}
                            >
                              <DropdownItem
                                onClick={() => {
                                  handleTypeSelect("With Email");
                                  setCurrentPage(1);
                                }}
                                style={{ border: "none", color: "#FFB000" }}
                              >
                                With Email
                              </DropdownItem>
                              <DropdownItem
                                onClick={() => {
                                  handleTypeSelect("With Wallet");
                                  setCurrentPage(1);
                                }}
                                style={{ border: "none", color: "#FFB000" }}
                              >
                                With Wallet
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </FormGroup>
                      </Col>

                      {/* Download CSV Button */}
                      <Col xs="12" sm="4" md="2">
                        <Button
                          color="white"
                          onClick={downloadCSV}
                          style={{ width: "100%", fontSize: "13px" }}
                        >
                          Download CSV
                        </Button>
                      </Col>

                      {/* Download PDF Button */}
                      <Col xs="12" sm="4" md="2">
                        <Button
                          color="white"
                          onClick={downloadPDF}
                          style={{ width: "100%", fontSize: "13px" }}
                        >
                          Download PDF
                        </Button>
                      </Col>

                      {/* Insert Transaction Button */}
                      {/* <Col xs="12" sm="4" md="3">
    <Button color="primary" onClick={handleModalToggle} style={{ width: '80%',fontSize:'13px' }}>
      Insert Transaction
    </Button>
  </Col> */}
                    </Row>

                    <Row></Row>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Table */}
        <Row>
          <div className="col" style={{ background: "#251d0c"}}>
            <Card
              className="shadow"
              style={{ backgroundColor: "rgba(1,1,1,0.5)", color: "white" }}
            >
              <CardHeader
                className="border-0"
                style={{ backgroundColor: "rgba(1,1,1,0.5)", color: "white" }}
              >
                <h3
                  className="mb-0"
                  style={{
                    color: "white",
                    background: "rgba(1,1,1,0.5)",
                    fontSize: "30px",
                  }}
                >
                  Transaction List
                </h3>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead
                  className=""
                  style={{
                    backgroundColor: "rgba(1,1,1,0.5)",
                    color: "white",
                    border: "none",
                    fontSize: "10px",
                  }}
                >
                  <tr>
                    <th
                      style={{
                        fontSize: "17px",
                        border: "none",
                        fontSize: "10px",
                      }}
                      scope="col"
                    >
                      Order Number
                    </th>
                    <th
                      style={{
                        fontSize: "17px",
                        border: "none",
                        fontSize: "10px",
                      }}
                      scope="col"
                    >
                      Price
                    </th>
                    {/* <th style={{ fontSize: '17px', border: 'none' ,fontSize:'10px'}} scope="col">Created Date</th> */}
                    <th
                      style={{
                        fontSize: "17px",
                        border: "none",
                        fontSize: "10px",
                      }}
                      scope="col"
                    >
                      Amount
                    </th>
                    <th
                      style={{
                        fontSize: "17px",
                        border: "none",
                        fontSize: "10px",
                      }}
                      scope="col"
                    >
                      Tokens
                    </th>
                    {/* <th style={{ fontSize: '17px', border: 'none' ,fontSize:'10px'}} scope="col">Order Status</th> */}
                    {/* <th style={{ fontSize: '17px', border: 'none' ,fontSize:'10px'}} scope="col">Pay Frequancy</th> */}
                    {/* <th style={{ fontSize: '17px', border: 'none' ,fontSize:'10px'}} scope="col">Bonus Code</th> */}
                    <th
                      style={{
                        fontSize: "17px",
                        border: "none",
                        fontSize: "10px",
                      }}
                      scope="col"
                    >
                      Pay Method
                    </th>
                    <th
                      style={{
                        fontSize: "17px",
                        border: "none",
                        fontSize: "10px",
                      }}
                      scope="col"
                    >
                      Email/Wallet
                    </th>
                    <th
                      style={{
                        fontSize: "17px",
                        border: "none",
                        fontSize: "10px",
                      }}
                      scope="col"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody style={{ border: "none", fontSize: "10px" }}>
                  {loading ? (
                    <tr>
                      <td
                        colSpan="7"
                        style={{
                          textAlign: "center",
                          padding: "20px",
                          border: "none",
                        }}
                      >
                        <Spinner color="primary" /> {/* Loading Spinner */}
                        <p
                          style={{
                            color: "white",
                            fontSize: "12px",
                            marginTop: "10px",
                          }}
                        >
                          Loading...
                        </p>
                      </td>
                    </tr>
                  ) : (
                    // Render each order dynamically
                    currentItems.map((order) => (
                      <React.Fragment key={order.orderId}>
                        <tr
                          style={{
                            backgroundColor: "rgba(1,1,1,0.5)",
                            border: "none",
                            fontSize: "10px",
                            paddingLeft: "0",
                          }}
                        >
                          <th
                            scope="row"
                            style={{ border: "none", fontSize: "10px" }}
                          >
                            <Media
                              className="align-items-center"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Media>
                                {order.status.toLowerCase() === "confirmed" ? (
                                  <FaCheck
                                    style={{
                                      color: "green",
                                      marginRight: "8px",
                                      fontSize: "20px",
                                    }}
                                  />
                                ) : order.status.toLowerCase() === "pending" ? (
                                  <FaRegClock
                                    style={{
                                      color: "orange",
                                      marginRight: "8px",
                                      fontSize: "30px",
                                      height: "30px",
                                    }}
                                  />
                                ) : null}
                                <span
                                  style={{ color: "white", fontSize: "10px" }}
                                >
                                  {order.orderId}
                                  <br />
                                  {new Date(
                                    order.createdAt,
                                  ).toLocaleDateString()}
                                </span>
                              </Media>
                            </Media>
                          </th>

                          <td style={{ border: "none", fontSize: "10px" }}>
                            <span style={{ color: "white", fontSize: "10px" }}>
                              {order.metadata?.priceAtPurchaseUSD ||
                                order?.priceAtPurchaseUSD ||
                                "N/A"}
                            </span>
                          </td>

                          <td style={{ border: "none", fontSize: "10px" }}>
                            <span style={{ color: "white", fontSize: "10px" }}>
                              {order.usdAmount}
                              <br />
                              {order.currency}
                            </span>
                          </td>

                          <td style={{ border: "none", fontSize: "10px" }}>
                            <span style={{ color: "white", fontSize: "10px" }}>
                              {Number(order.amountWagr).toLocaleString()}
                              <br />
                              <span
                                style={{ color: "white", fontSize: "10px" }}
                              >
                                Bonus Code : {order?.promoCode || "N/A"}
                              </span>
                            </span>
                          </td>

                          <td
                            style={{
                              color: "white",
                              border: "none",
                              fontSize: "10px",
                            }}
                          >
                            {order.paymentMethod}
                            <br />
                            {order.status}
                          </td>

                          <td
                            style={{
                              color: "white",
                              border: "none",
                              fontSize: "10px",
                            }}
                          >
                            {order.email}
                            <br />
                            <span style={{ opacity: "0.2", fontSize: "10px" }}>
                              Country: {order.country}
                            </span>
                          </td>

                          <td style={{ border: "none", paddingLeft: "0" }}>
                            <Button
                              color="info"
                              style={{ fontSize: "10px",marginLeft: "15px", paddingLeft: "15px" , paddingRight: "15px" , paddingTop: "9px" , paddingBottom: "9px" }}
                              onClick={() => handleViewClick(order)}
                            >
                              View
                            </Button>
                            {/* <Button
                              color="primary"
                              onClick={() => handleEditTokenClick(order)}
                              style={{ padding: "9px", fontSize: "10px" }}
                            >
                              Token
                            </Button> */}

                            {/* <Button
                              color="primary"
                              style={{ fontSize: "10px", padding: "9px" }}
                              onClick={() => handleEditClick(order)}
                            >
                              Edit
                            </Button> */}
                          </td>
                        </tr>

                        {/* New row for transaction hash and wallet address */}
                        <tr style={{ border: "none", paddingLeft: "0" }}>
                          <td
                            colSpan="7"
                            style={{ padding: "5px", border: "none" }}
                          >
                            <div
                              style={{
                                color: "white",
                                fontSize: "10px",
                                wordWrap: "break-word",
                              }}
                            >
                              <strong>Wallet Address:</strong> {order.wallet}
                            </div>
                            <div
                              style={{
                                color: "white",
                                fontSize: "10px",
                                wordWrap: "break-word",
                              }}
                            >
                              <strong>Transaction Hash:</strong>{" "}
                              {order
                                ? order.txHash || order.providerPaymentId
                                : "—"}
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))
                  )}
                </tbody>
              </Table>
            </Card>
            <div
              style={{ width: "100%", display: "flex", justifyContent: "end" }}
            >
              {renderPagination()}
            </div>
            <br />
            <br />
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Tables;
